import React, {useEffect, useState} from 'react';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';

import {login_router_url} from '../communication_system/inner_router_url';
import {sidebarData} from '../dataSystems/SidebarData';

import Layout from '../components/Layouts/Layout';
import Login from '../pages/login/Login';
import PaymentDetailEmbed, {PAYMENT_DETAIL_RETURN_KEY, validatedPaymentDetailPath} from '../pages/gathering/PaymentDetailEmbed';

/** 라우터 설정 */
const TotalRouter = () => {
    const [userId, setUserId] = useState('');
    const [pathName, setPathName] = useState('');
    const [isMount, setIsMount] = useState(false);

    const loginRoute = (id) => {
        setUserId(id);
        localStorage.setItem('user_id', id);
    };

    const logoutRoute = () => {
        setUserId('');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('user_id');
        localStorage.removeItem('user');
    };

    const storedPaymentDetailPath = () => {
        const saved = window.sessionStorage.getItem(PAYMENT_DETAIL_RETURN_KEY) || '';
        const validated = validatedPaymentDetailPath(saved);
        if (saved && !validated) window.sessionStorage.removeItem(PAYMENT_DETAIL_RETURN_KEY);
        return validated;
    };

    const paymentDetailLoginRoute = (id) => {
        const currentPath = validatedPaymentDetailPath(`${window.location.pathname}${window.location.search}`);
        const returnPath = currentPath || storedPaymentDetailPath();
        if (returnPath) window.sessionStorage.setItem(PAYMENT_DETAIL_RETURN_KEY, returnPath);
        else window.sessionStorage.removeItem(PAYMENT_DETAIL_RETURN_KEY);
        loginRoute(id);
        if (!returnPath) return;
        window.setTimeout(() => {
            window.history.replaceState({}, '', returnPath);
            window.dispatchEvent(new PopStateEvent('popstate'));
        }, 0);
    };

    useEffect(() => {
        setUserId(localStorage.getItem('user_id'));
        setPathName(localStorage.getItem('last_path'));
        setIsMount(true);
    }, []);

    useEffect(() => {
        localStorage.setItem('last_path', window.location.pathname === '/' ? '/home' : window.location.pathname);
    }, [window.location.pathname]);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/gathering/payment-detail" element={isMount ? (Boolean(userId) ? <PaymentDetailEmbed /> : <Login authenticate={paymentDetailLoginRoute} />) : null} />
                {!Boolean(userId) && <Route path={login_router_url} element={<Login authenticate={storedPaymentDetailPath() ? paymentDetailLoginRoute : loginRoute} />} />}
                {isMount && !Boolean(userId) && <Route path="*" element={<Navigate to={'/login'} />} />}
                {isMount && Boolean(userId) && <Route path="*" element={<Navigate to={pathName || '/home'} />} />}
                {Boolean(userId) && (
                    <Route element={<Layout logout={logoutRoute} />}>
                        {sidebarData.map((main) => {
                            return main.subTitleList.map((sub) => {
                                return <Route path={sub.router_url} element={sub.components} />;
                            });
                        })}
                    </Route>
                )}
            </Routes>
        </BrowserRouter>
    );
};

export default React.memo(TotalRouter);
